import React from 'react';
import { faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import SlideForm from '../common/forms/SlideForm';
import { Input, toasty } from '../common/forms/FormElements';
import CommonContext, { ApiRoutes } from '../Common';

class BaseCreateNewHoliday {
    name = '';
    description = '';
    date = '';
}

export default class CreateHolidayForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        this.state = {
            createNewHoliday: new BaseCreateNewHoliday(),

            formValidated: false,
            loading: false,
            errors: null,
        };
    }

    onClose = () => {
        this.setState({
            createNewHoliday: new BaseCreateNewHoliday(),
            formValidated: false,
            loading: false,
            errors: null,
        });

        if (this.props.onClose) {
            this.props.onClose();
        }

        this.context.setFormOpened(false);
    };

    onSubmit = async () => {
        const {
            isCompanyHoliday, isGroupedHoliday, companyId, countyGroupId, holidayGroupTenantId,
        } = this.props;
        const { createNewHoliday } = this.state;

        if (!createNewHoliday.name || !createNewHoliday.date) {
            toasty.error('Please provide a holiday name and date.');
            return;
        }

        try {
            this.setState({ loading: true });

            let endpoint;
            if (isCompanyHoliday) {
                endpoint = ApiRoutes.holiday.createCompanyHolidays(companyId);
            } else if (isGroupedHoliday) {
                endpoint = ApiRoutes.holiday.createHolidayGroupHolidays(holidayGroupTenantId);
            } else {
                endpoint = ApiRoutes.holiday.createCountyGroupHolidays(countyGroupId);
            }

            const response = await httpClient.post(endpoint, createNewHoliday);

            // Success only if the response is (or can be coerced to) a finite number
            const newId = Number(response);
            if (Number.isFinite(newId)) {
                toasty.success('New Holiday Created');

                const newHolidayOption = {
                    value: newId,
                    label: createNewHoliday.name,
                    date: createNewHoliday.date,
                };

                if (this.props.onHolidayCreated) {
                    this.props.onHolidayCreated(newHolidayOption);
                }
            } else {
                const message =
                    (typeof response === 'string' && response) ||
                    response?.message ||
                    response?.error ||
                    'Error creating holiday.';
                toasty.error(message);
            }
            this.onClose();
        } catch (ex) {
            console.error(ex);
            toasty.error('Error creating holiday.');
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { show } = this.props;
        const {
            createNewHoliday, formValidated, loading, errors,
        } = this.state;

        return (
            <SlideForm
                loading={loading}
                show={show}
                id="add-holiday-form"
                formIcon={faAddressCard}
                formTitle="Add New Holiday"
                ref={this.formRef}
                setIsValidated={(val) => this.setState({ formValidated: val })}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={errors}
            >
                <Input
                    label="Holiday Name"
                    id="holidayName"
                    name="holidayName"
                    value={createNewHoliday.name}
                    onChange={(e) =>
                        this.setState({
                            createNewHoliday: {
                                ...createNewHoliday,
                                name: e.target.value,
                            },
                        })
                    }
                    placeholder="Enter Holiday Name"
                    maxLength={100}
                    error="Holiday Name is required."
                    required
                />

                <Input
                    label="Description (Optional)"
                    id="holidayDescription"
                    name="holidayDescription"
                    value={createNewHoliday.description}
                    onChange={(e) =>
                        this.setState({
                            createNewHoliday: {
                                ...createNewHoliday,
                                description: e.target.value,
                            },
                        })
                    }
                    placeholder="Enter a description"
                    maxLength={100}
                />

                <Input
                    label="Holiday Date"
                    id="holidayDate"
                    name="holidayDate"
                    type="date"
                    required
                    value={createNewHoliday.date}
                    error="Holiday Date is Required"
                    onChange={(e) =>
                        this.setState({
                            createNewHoliday: {
                                ...createNewHoliday,
                                date: e.target.value,
                            },
                        })
                    }
                />
            </SlideForm>
        );
    }
}